import FancyBoxSvg230x200 from './FancyBoxSvg230x200';

export default FancyBoxSvg230x200;
export { FancyBoxSvg230x200 };
